import React from "react";
import { CorrectionAmountCell, CorrectionEditableCell } from "./CorrectionCells";
import {
  formatSignedDelta,
  readModuleCorrectionValue,
  sumModuleRoleCorrectionImpact,
} from "./correctionStorage";

export const ModuleCorrectionRows = ({
  module,
  roles = [],
  corrections = [],
  onChange = () => {},
  getBaseDays = (role) => Number(role?.day_efforts?.direct) || 0,
  editable = true,
}) => {
  if (!corrections?.length || !roles?.length) return null;
  const currentId = corrections[corrections.length - 1].id;

  return (
    <>
      {corrections.map((correction) => {
        const isCurrent = correction.id === currentId;
        return (
          <tr
            key={correction.id}
            className={
              isCurrent ? "correction-row-current" : "correction-row-past"
            }
          >
            <td>
              Корректировка {correction.number} (дн)
              {isCurrent ? (
                <span className="correction-row-current-mark">текущая</span>
              ) : null}
            </td>
            {roles.map((role, index) => (
              <td key={index} style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CorrectionEditableCell
                    value={readModuleCorrectionValue(
                      correction,
                      module,
                      role.role,
                      role.section_id,
                    )}
                    disabled={!isCurrent || !editable}
                    onCommit={(nextValue) =>
                      onChange(
                        correction.id,
                        module,
                        role.role,
                        role.section_id,
                        nextValue,
                      )
                    }
                  />
                </div>
              </td>
            ))}
          </tr>
        );
      })}
      <tr className="correction-row-total">
        <td>Итого с корректировками (дн)</td>
        {roles.map((role, index) => {
          const extra = sumModuleRoleCorrectionImpact(
            corrections,
            module,
            role.role,
            role.section_id,
          );
          const total = getBaseDays(role, index) + extra.day_efforts;
          const changed = extra.day_efforts !== 0;
          return (
            <td
              key={index}
              className={changed ? "correction-sum-changed" : ""}
              style={{ textAlign: "center", fontWeight: 700 }}
            >
              {Number(total.toFixed(1))}
              {changed ? (
                <span
                  className={`correction-sum-delta${
                    extra.day_efforts < 0 ? " is-negative" : ""
                  }`}
                >
                  {formatSignedDelta(extra.day_efforts)}
                </span>
              ) : null}
            </td>
          );
        })}
      </tr>
    </>
  );
};

export const ModuleBonusDayCells = ({ module, roles, corrections }) =>
  (roles || []).map((role, index) => {
    const extra = sumModuleRoleCorrectionImpact(
      corrections,
      module,
      role.role,
      role.section_id,
    );
    return (
      <CorrectionAmountCell
        key={index}
        base={role.day_efforts?.bonus || 0}
        extra={extra.bonus_day_efforts}
        digits={1}
      />
    );
  });

export const ModuleDirectMoneyCells = ({ module, roles, corrections }) =>
  (roles || []).map((role, index) => {
    const extra = sumModuleRoleCorrectionImpact(
      corrections,
      module,
      role.role,
      role.section_id,
    );
    return (
      <CorrectionAmountCell
        key={index}
        base={role.money_expenditures?.direct || 0}
        extra={extra.money_expenditures}
        money
        prefix="₸ "
      />
    );
  });

export const ModuleBonusMoneyCells = ({ module, roles, corrections }) =>
  (roles || []).map((role, index) => {
    const extra = sumModuleRoleCorrectionImpact(
      corrections,
      module,
      role.role,
      role.section_id,
    );
    return (
      <CorrectionAmountCell
        key={index}
        base={role.money_expenditures?.bonus || 0}
        extra={extra.bonus_money_expenditures}
        money
        prefix="₸ "
      />
    );
  });
